// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPermissionDto
 */
export interface IPermissionDto {
    /**
     * 
     * @type {number}
     * @memberof IPermissionDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPermissionDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof IPermissionDto
     */
    group_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPermissionDto
     */
    group_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPermissionDto
     */
    display_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPermissionDto
     */
    description?: string;
}

/**
 * Check if a given object implements the IPermissionDto interface.
 */
export function instanceOfIPermissionDto(value: object): value is IPermissionDto {
    return true;
}

export function IPermissionDtoFromJSON(json: any): IPermissionDto {
    return IPermissionDtoFromJSONTyped(json, false);
}

export function IPermissionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPermissionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'group_id': json['group_id'] == null ? undefined : json['group_id'],
        'group_name': json['group_name'] == null ? undefined : json['group_name'],
        'display_name': json['display_name'] == null ? undefined : json['display_name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function IPermissionDtoToJSON(json: any): IPermissionDto {
    return IPermissionDtoToJSONTyped(json, false);
}

export function IPermissionDtoToJSONTyped(value?: IPermissionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'group_id': value['group_id'],
        'group_name': value['group_name'],
        'display_name': value['display_name'],
        'description': value['description'],
    };
}

